var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
const SvgShare = _a => {
  var {
      size
    } = _a,
    props = __rest(_a, ["size"]);
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: size || 24,
    height: size || 24,
    viewBox: "0 0 24 24",
    role: props.role,
    "aria-hidden": props['aria-hidden'] || true
  }, props), React.createElement("path", {
    fill: props.color || 'currentColor',
    fillRule: "evenodd",
    d: "M12.75,3.81066017 L12.75,15 C12.75,15.4142136 12.4142136,15.75 12,15.75 C11.5857864,15.75 11.25,15.4142136 11.25,15 L11.25,3.81066017 L8.53033009,6.53033009 C8.23743687,6.8232233 7.76256313,6.8232233 7.46966991,6.53033009 C7.1767767,6.23743687 7.1767767,5.76256313 7.46966991,5.46966991 L11.4696699,1.46966991 C11.7625631,1.1767767 12.2374369,1.1767767 12.5303301,1.46966991 L16.5303301,5.46966991 C16.8232233,5.76256313 16.8232233,6.23743687 16.5303301,6.53033009 C16.2374369,6.8232233 15.7625631,6.8232233 15.4696699,6.53033009 L12.75,3.81066017 Z M3.25,12 C3.25,11.5857864 3.58578644,11.25 4,11.25 C4.41421356,11.25 4.75,11.5857864 4.75,12 L4.75,20 C4.75,20.6903559 5.30964406,21.25 6,21.25 L18,21.25 C18.6903559,21.25 19.25,20.6903559 19.25,20 L19.25,12 C19.25,11.5857864 19.5857864,11.25 20,11.25 C20.4142136,11.25 20.75,11.5857864 20.75,12 L20.75,20 C20.75,21.5187831 19.5187831,22.75 18,22.75 L6,22.75 C4.48121694,22.75 3.25,21.5187831 3.25,20 L3.25,12 Z"
  }));
};
export default SvgShare;